import { render } from "./CocktailEditor.vue?vue&type=template&id=2893c645&scoped=true"
import script from "./CocktailEditor.vue?vue&type=script&lang=js"
export * from "./CocktailEditor.vue?vue&type=script&lang=js"

import "./CocktailEditor.vue?vue&type=style&index=0&id=2893c645&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2893c645"]])

export default __exports__